<template>    
  <div id="divContainerIFrame" class="containerIFrame">
    <div v-show="showNavegacaoFuncionario && indexAba >= 0">
      <div>
        <ul class="nav nav-tabs nav-fill">
          <li class="nav-item" @click="AbrirConteudo('funcionario_consultar_cliente', 0)">
            <a href="javascript:;" target="_self" class="nav-link" v-bind:class="{'active' : indexAba === 0 }">Consultar
              cliente</a>
          </li>
          <li class="nav-item" @click="AbrirConteudo('funcionario_hoteis_conveniados', 1)">
            <a href="javascript:;" target="_self" class="nav-link" v-bind:class="{'active' : indexAba === 1 }">Hotéis
              conveniados</a>
          </li>
          <li class="nav-item" @click="AbrirConteudo('funcionario_buscar_hotel', 2)">
            <a href="javascript:;" target="_self" class="nav-link" v-bind:class="{'active' : indexAba === 2 }">Página do
              hoteleiro </a>
          </li>
        </ul>
      </div>
    </div>
    <transition enter-active-class="animated fadeIn">
      <b-row style="height: 100%;" v-show="UrlHotelSys && showIframe">
        <b-col>
          <iframe id="iframeContainer" ref="containerHotelSys" width="100%" height="100%" v-if="token"
                  :src="UrlHotelSys"></iframe>
        </b-col>
      </b-row>
    </transition>
  </div>
</template>

<script>
    import TokenService from '../services/TokenService'
    import UtilService from '../services/UtilService'
    import LocalStorageService from '../services/LocalStorageService'

    export default {
        name: 'IFrameHoteleiro',
        data() {
            return {
                indexAba: 0,
                showNavegacaoFuncionario: false,
                showIframe: true,
                token: null,
                idHotel: 0,
                idPessoa: 0,
                UrlHotelSys: '',
                itemMenu: null,
                hotelSelecionado: null,
                ignoreChangeUrl: false
            }
        },
        created() {
            this.localStorageService = new LocalStorageService()
            this.util = new UtilService(this)
            this.tokenService = new TokenService()
            let ref = this
            this.token = this.tokenService.TokenSession()
            this.addEventIframe()
            this.GetHotelSelecionado(this.$parent.hotelSelecionado);
            window.addEventListener('message', this.RedirectIframe, false);
        },
        mounted() {
            document.getElementsByClassName('container-fluid')[0].style.height = '100%'
            this.ClickMenuEsquerdo()
            this.updateBreadgrumb('Início')
            this.removeBreadcrumb()
        },
        methods: {
            RedirectIframe(evt) {
                if (evt.data && evt.data === 'exibirMenuLateral') {
                    this.util.VerificarHotelSelecionado(null, true);
                }
            },
            GetHotelSelecionado(hotel) {
                let userCache = this.localStorageService.Get(process.env.VUE_APP_USUARIO_LOGADO)
                if (userCache) this.showNavegacaoFuncionario = userCache.eFuncionario
                this.hotelSelecionado = hotel
                if (this.hotelSelecionado) {
                    this.util.Loading(true)
                    this.idHotel = hotel.Id;
                    this.idPessoa = hotel.PssCodigo;
                } else {
                    if (userCache) {
                        this.idPessoa = userCache.PessoaID
                    } else {
                        let ref = this
                        setTimeout(() => {
                            ref.GetHotelSelecionado(hotel)
                        }, 1000)
                    }
                }
                this.startUrlHotelSys();
            },
            removeBreadcrumb() {
                let ref = this
                if (document.getElementsByClassName('breadcrumb-item').length > 0) {
                    document.getElementsByClassName('breadcrumb-item')[0].remove()
                } else {
                    setTimeout(() => {
                        ref.removeBreadcrumb()
                    }, 1000)
                }
            },
            addEventIframe() {
                let ref = this
                if (ref.$refs.containerHotelSys) {
                    ref.$refs.containerHotelSys.onload = function () {
                        ref.util.Loading(false)
                        ref.showIframe = true
                    }
                    ref.startUrlHotelSys()
                } else
                    setTimeout(() => {
                        ref.addEventIframe()
                    }, 100)
            },
            startUrlHotelSys() {
                if (this.token && this.idPessoa > 0) {
                    let eFuncionario = this.localStorageService.Get(process.env.VUE_APP_USUARIO_LOGADO).eFuncionario;
                    if (!eFuncionario) {
                        let url = process.env.VUE_APP_URL_BBRAS +
                            'site/br/institucional/login.aspx?' +
                            'action=dologin&tokenExterno={0}&sistema=' + process.env.VUE_APP_IDENTIFICADOR_HOTEL_SYS + '&psspessoa={1}'
                        this.UrlHotelSys = url.replace('{0}', this.token).replace('{1}', this.idPessoa)
                    } else {
                        let teste = process.env.VUE_APP_URL_BBRAS;
                        let urlHoteleiro = process.env.VUE_APP_URL_HOTELEIRO_AUTH;
                        this.UrlHotelSys = urlHoteleiro.replace('{0}', this.token).replace('{1}', 'funcionariocbtur');
                    }
                } else this.UrlHotelSys = null;
                console.log('Url iframe: ' + this.UrlHotelSys);
                if (this.idPessoa === 0) {
                    let ref = this
                    setTimeout(() => {
                        ref.startUrlHotelSys()
                    }, 300)
                }
            },
            ClickMenuEsquerdo() {
                let elementos = document.getElementsByClassName('nav-item')
                if (elementos) {
                    for (var counter = 0; counter < elementos.length; counter++) {
                        let elemento = elementos[counter];
                        elemento.addEventListener("click", this.AbrirConteudo);
                    }
                }
            },
            AbrirConteudo(item, indexAba) {
                let outerText = item && item.currentTarget ? item.currentTarget.textContent.trim() : "";
                if (item && item.currentTarget && this.itemMenu == outerText)
                    this.ignoreChangeUrl = true;

                if (!this.ignoreChangeUrl) {
                    if (item.currentTarget && item.currentTarget.innerHTML.indexOf('nav-dropdown-toggle') === -1) {
                        this.util.Loading(true)
                        this.showIframe = false
                        let target = outerText
                        this.itemMenu = target
                        this.UrlHotelSys = process.env.VUE_APP_URL_BBRAS + this.GetUrlTarget(this.itemMenu)
                    } else if (item.startsWith && item.startsWith('funcionario_')) {
                        this.util.Loading(true)
                        this.UrlHotelSys = process.env.VUE_APP_URL_BBRAS + this.GetUrlTarget(item)
                        this.ignoreChangeUrl = true
                    }
                    if (indexAba >= 0)
                        this.indexAba = indexAba
                    else
                        this.indexAba = -1
                } else {
                    this.ignoreChangeUrl = false
                }
            },
            /** @return {string} */
            GetUrlTarget(target) {
                this.updateBreadgrumb(target);
                console.log('Target: ' + target);
                switch (target.toLowerCase()) {
                    case 'início':
                        return '/hotelsys/navegar.aspx';
                    case 'pesquisar reservas':
                        return '/hotelsys/pesquisa_roominglist.aspx';
                    case 'solicitação eb':
                        return '/hotelsys/eb_reservamarcada.aspx'
                    case 'pedido de revisão':
                        return '/hotelsys/eb_pedidorevisao.aspx';
                    case 'rooming list':
                        return '/hotelsys/pagePrinRoomingList.aspx';
                    case 'cancelamentos':
                        return '/hotelsys/comunicado_cancelamento.aspx';
                    case 'alteração de reserva':
                        return '/hotelsys/comunicado_althosp.aspx';
                    case 'alterar senha':
                        return '/site/br/area_restrita/club_alterarsenha.aspx';
                    case 'temporário':
                        return '/hotelsys/roominglistTemporario_listar.aspx';
                    case 'definitivo':
                        return '/hotelsys/roominglist_listar.aspx';
                    case 'comunicado de novas reservas':
                        return '/hotelsys/pool_novasreservas.aspx';
                    case 'faturas':
                        return '/hotelsys/hotel_fatura.aspx';
                    case 'usuários':
                        return '/hotelsys/usuariointernet_gerenciar.aspx';
                    case 'funcionario_consultar_cliente':
                        return 'site/br/area_restrita/club_cliente_buscar.aspx';
                    case 'funcionario_hoteis_conveniados':
                        return 'site/br/area_restrita/club_hoteis_conveniados.aspx';
                    case 'funcionario_buscar_hotel':
                        return 'hotelsys/hotel_buscar.aspx';
                }
            },
            updateBreadgrumb(label) {
                if (label.toLowerCase().startsWith('funcionario')) {
                    label = 'Início'
                }
                try {
                    if (label === 'Definitivo' || label === 'Temporário')
                        label = 'Rooming List / ' + label
                    document.getElementsByClassName('breadcrumb')[0].getElementsByClassName('active')[0].textContent = label
                } catch(e) {
                    try {
                        document.getElementsByClassName('breadcrumb')[0].appendChild('<li class="breadcrumb-item"><span class="active">Início</span></li>')
                    } catch(e2) {
                        this.util.Loading(false)
                        console.log('Erro bread crumb',e2,e)
                    }
                }
            },
            fecharModal(){
                document.getElementById('modal-aviso').remove();                
            }
        },
        watch: {
            '$parent.hotelSelecionado': function (val) {
                this.GetHotelSelecionado(val)
                if (val.origemIFrame) {
                    document.location.href = document.location.href.substring(0, document.location.href.indexOf("?"))
                    this.UrlHotelSys = process.env.VUE_APP_URL_BBRAS + this.GetUrlTarget('início')
                    this.indexAba = -1
                    let ref = this
                    setTimeout(() => {
                        ref.util.Loading(false)
                    }, 1000)
                }
                this.util.VerificarHotelSelecionado(this.hotelSelecionado)
            }
        }
    }   
</script>

<style scoped>
  iframe {
    border: none;
  }

  .containerIFrame {
    height: 120%;
    padding: 20px;
    background: white;
    margin-bottom: 40px;
  }

  .active {
    border-top: 2px solid #20a8d8 !important;
  }

  .modalHot {
            position: fixed;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            font-family: Arial, Helvetica, sans-serif;
            background: rgba(0,0,0,0.8);
            z-index: 99999;
            opacity: 1;
            -webkit-transition: opacity 400ms ease-in;
            -moz-transition: opacity 400ms ease-in;
            transition: opacity 400ms ease-in;
            pointer-events: auto;
        }

            .modalHot > div {
                width: 420px;
                height: auto !important;
                position: relative;
                margin: 5% auto;
                padding: 0px;
                background: #fff;
            }
</style>
